import styled from 'styled-components';

import { SlotMachineAnimatedNumber } from '@sorare/core/src/atoms/animations/SlotMachineAnimatedNumber';
import { CircularProgress } from '@sorare/core/src/atoms/loader/CircularProgress';
import { LabelL, LabelS } from '@sorare/core/src/atoms/typography';

const Wrapper = styled.div`
  display: flex;
  gap: var(--half-unit);
`;

const StyledProgress = styled(CircularProgress)`
  width: var(--intermediate-unit);
  --circular-progress-stroke: var(--c-onBase-success);
`;

type Props = {
  ownedCards: number;
  addedCards: number;
  totalCards: number;
};

export const AnimatedCardsNumber = ({
  ownedCards,
  addedCards,
  totalCards,
}: Props) => {
  return (
    <Wrapper>
      <span>
        <LabelL bold as="span">
          <SlotMachineAnimatedNumber value={ownedCards + addedCards} />
        </LabelL>
        <LabelS as="span" color="var(--c-nd-700)">
          /{totalCards}
        </LabelS>
      </span>

      <StyledProgress maxProgress={totalCards} progress={ownedCards} />
    </Wrapper>
  );
};
